<template>
    <div class="status">
        <div class="statusCon to-examine" v-if="is_success === 0">
            <span v-if="is_examine === 0">订单正在审核中，请耐心等候</span>
            <span v-if="is_examine === 2">订单已拒绝</span>
            <span v-if="is_examine === 3">订单未通过</span>
        </div>
        <div class="statusCon conduct" v-if="is_success === 1">订单正在进行中</div>
        <div class="statusCon completed" v-if="is_success === 2">订单已完成</div>
    </div>
</template>
<script>
export default {
  name: 'ExtensionStatus',
    props: {
        is_success: Number,
        is_examine: Number
    }
}
</script>
<style scoped>
    .status{margin-bottom:30px;}
    .status .statusCon{height:46px;line-height:46px;padding:0 20px;font-size:14px;border-radius: 4px;}
    .status .to-examine{background: #fdf6ec;color:#FE9539;}
    .status .completed{background: #f4f4f5;color:#909399;}
    .status .conduct{background: #f0f9eb;color:#67c23a;}
</style>
